import {ClsConfig} from '../../util/cls-config';
import {GenericoService} from '../../core/services/generico.service';
import {AppPresupuestosService} from '../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../core/services/app-info.service';
import {ClsUtil} from '../../util/cls-util';
import {ClsRespuestaActualizacionConsulta} from '../../core/models/peticiones/cls-pr-actualizacion-consulta';
import {KeyVentanaPreviewExcel, ProveedorLogin} from '../../core/models/enum/emun-enumeracion';
import {EnumTipoParametro} from '../../core/models/enum/enum-tipo-parametro';
import {EnumLibros, EnumParaPpto, EnumParaUsu} from '../../core/models/enum/enum-parametros';
import {ClsObjPresupuesto} from '../01-presupuesto/presupuesto/cls-obj-presupuesto';
import {ClsObjPresupuestoPartidas} from '../01-presupuesto/presupuesto/cls-obj-presupuesto-partidas';
import {ClsObjExplosionDeInsumos} from '../01-presupuesto/menu-presupuesto/cls-obj-explosion-de-insumos';
import {ClsObjCatalogoPresupuestosGenerales} from '../cls-obj-catalogo-presupuestos-generales';
import {
  ClsRespuestaLimitesPorUsuario,
  ClsRespuestaLimitesPptoPu
} from '../../core/models/peticiones/cls-pr-limite-presupuesto';
import {
  ClsPeticionGenerarArchivoIntercambio,
  ClsPeticionObtieneUltimoModifico,
  ClsPeticionPresupuestos,
  ClsRespuestaCatMatrizStorage,
  ClsRespuestaFechasConsultas,
  ClsRespuestaUltimoModifico
} from '../../core/models/peticiones/cls-pr-generico';
import {
  ClsPeticionRecibirArchivoIntercambio, ClsPeticionUnirArchivosIntercambios,
  ClsRespuestaGenerarArchivoIntercambio, ClsUnirArchivosIntercambios
} from '../../core/models/peticiones/cls-pr-recibir-archivo-intercambio';
import {ClsRespustaDepurarPresupuesto} from '../../core/models/peticiones/cls-pr-depurar-presupuesto';
import {
  ClsPeticionObtieneParametros,
  ClsRespuestaParametros
} from '../../core/models/peticiones/cls-pr-parametros';
import {ClsRespuestaPresupuestos} from '../../core/models/peticiones/cls-pr-presupuestos';
import {
  ClsPeticionEliminarObtieneBucketStorage,
  ClsPeticionEnListaArchivosStorage,
  ClsPeticionSubeArchivoStorage,
  ClsPeticionSubeListaArchivosStorageV2,
  ClsRespuestaDescargaArchivosStorage, ClsRespuestaDescargaArchivosStorage2, ClsRespuestaEliminarObtieneBucketStorage,
  ClsRespuestaEnListaArchivosStorage,
  ClsRespuestaSubeArchivoStorage,
  ClsRespuestaSubeListaArchivosStorageV2,
  ClsDatosBucketSube
} from '../../core/models/peticiones/cls-pr-storage';
import {ClsObjCalculo} from '../01-presupuesto/calculo/cls-obj-calculo';
import {
  DmSecundarioComponent
} from '../../componentes/00-contenedores/docker-manager/dmseundario/dm-secundario.component';
import {
  DmCatalogosGralsComponent
} from '../../componentes/00-contenedores/docker-manager/dmcatalogosgrals/dm-catalogos-grals.component';
import {
  DetalleDelPresupuestoComponent
} from '../../componentes/01-presupuesto/detalle-del-presupuesto/detalle-del-presupuesto.component';
import {ClsObjCostoHorario} from '../01-presupuesto/presupuesto/cls-obj-costo-horario';
import {ClsObjSobrecosto} from '../01-presupuesto/presupuesto/cls-obj-sobrecosto';
import {EnumMIMETypes} from '../../core/models/enum/enum-mas-opciones';
import {
  ClsPeticionListaLicenciasVigentes,
  ClsRespuestaListaLicenciasVigentes
} from '../../core/models/peticiones/cls-pr-cambio-de-propietario';
import {ClsObjMatrices} from '../01-presupuesto/matrices/cls-obj-matrices';
import {ClsActualizacionConsulta} from 'src/app/core/models/cls-actualizacion-consulta';
import {ClsArchivoBase64, ClsDataEnvioCorreo, ClsEnviarCorreo} from 'src/app/core/models/cls-envio-correo';
import {ClsErrores} from 'src/app/core/models/cls-errores';
import {ClsParametro} from 'src/app/core/models/cls-parametros';
import {ClsCatalogoPresupuestos, ClsPresupuestos} from 'src/app/core/models/cls-presupuestos';
import {ClsArchivosEntrada, ClsContenidoBucketStorage, ClsListaArchivos} from 'src/app/core/models/cls-storage';
import {ClsLicenciasPU} from "../../core/models/cls-cambio-de-propietario";
import {inject} from "@angular/core";
import {ClsObjFasar} from "../01-presupuesto/presupuesto/cls-obj-fasar";
import {ListaDocumentosComponent} from "../../componentes/util/ventanas/lista-documentos/lista-documentos.component";
import {VtnGenericaComponent} from "../../componentes/util/ventanas/vtn-generica/vtn-generica.component";
import {
  VistaPreviaExcelComponent
} from 'src/app/componentes/util/ventanas/vista-previa-excel/vista-previa-excel.component';
import {ClsObjParametrosPorPpto} from './cls-obj-parametros-por-ppto';
import {ClsCliente} from "../../core/models/cls-cliente";
import {
  ExplosionDeInsumosComponent
} from "../../componentes/01-presupuesto/menu-presupuesto/explosion-de-insumos/explosion-de-insumos.component";
import {
  PptoCompletoComponent
} from "../../componentes/01-presupuesto/menu-presupuesto/ppto-completo/ppto-completo.component";
import {
  ManoDeObraComponent
} from "../../componentes/01-presupuesto/menu-presupuesto/mano-de-obra/mano-de-obra.component";
import {MaterialesComponent} from "../../componentes/01-presupuesto/menu-presupuesto/materiales/materiales.component";
import {MaquinariaComponent} from "../../componentes/01-presupuesto/menu-presupuesto/maquinaria/maquinaria.component";
import {MatrizActivoComponent} from "../../componentes/01-presupuesto/matrices/matriz-activo/matriz-activo.component";
import {ClsMatriz} from "../../core/models/cls-matriz";
import {setTimeout} from "worker-timers";
import {TipoMensajesService} from "../../core/services/tipo-mensajes.service";
import {CrearComponenteDinamicoService} from "../../core/services/crear-componente-dinamico.service";
import {ClsObjCatProgramacionObra} from "../01-presupuesto/programacion-obra/cls-obj-cat-programacion-obra";
import {
  BusquedaAIMatrizFilter,
  BusquedaAITipoFilter,
  ClsBusquedaAIResultado,
  ClsPeticionBusquedaAI,
  ClsRespuestaVectorSearchResponse,
  ClsVectorSearchResult,
  ClsVectorSearchRow,
  ValidationErrorDetail
} from "../../core/models/cls-busqueda-ai";
import {INeodataMenu} from "../../core/models/interfaces/generico-interface";
import {EnumMCGenerales} from "../../core/models/enum/enum-menu-contextual";

export class ClsObjGenerico extends ClsConfig {
  // OBJ
  public mObjParamPpto: ClsObjParametrosPorPpto = new ClsObjParametrosPorPpto();
  // private mObjParaUser: ClsObjParametrosPorUsuario = new ClsObjParametrosPorUsuario();
  // private mObjParaOrganizacion: ClsObjParametrosPorOrganizacion = new ClsObjParametrosPorOrganizacion();
  private mObjPresupuesto: ClsObjPresupuesto = new ClsObjPresupuesto();
  private mObjPresupuestoPartida: ClsObjPresupuestoPartidas = new ClsObjPresupuestoPartidas();
  private mObjExpInsumos: ClsObjExplosionDeInsumos = new ClsObjExplosionDeInsumos();
  private mObjCalculo: ClsObjCalculo = new ClsObjCalculo();
  private mObjCatalogoPptosGrals: ClsObjCatalogoPresupuestosGenerales = new ClsObjCatalogoPresupuestosGenerales();
  public mObjCH: ClsObjCostoHorario = new ClsObjCostoHorario();
  private mObjMatrices: ClsObjMatrices = new ClsObjMatrices();
  private mObjSobrecosto: ClsObjSobrecosto = new ClsObjSobrecosto();
  private mObjFasar: ClsObjFasar = new ClsObjFasar();
  private mObjProgramacionObra: ClsObjCatProgramacionObra = new ClsObjCatProgramacionObra();
  // menu contextual
  private menus: INeodataMenu[] = [];

  // Este campo se necesita mandar para validar si la matriz que se edito esta abierto
  // y se tenga que actualizar la informacion, principalmente cuando se trabaja multiusuario(muy raro que se de)
  public updateMatriz: ClsMatriz;
  private infPpto = inject(AppPresupuestosService);
  private servicioGen = inject(GenericoService);
  private infApp = inject(AppInfoService);
  public tipoMsg = inject(TipoMensajesService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  constructor() {
    super();
    this.mObjCH.mObjGenerico = this;
    this.mObjSobrecosto.mObjGenerico = this;
    this.mObjFasar.mObjGenerico = this;
  }

  public async peticionServidorLogin(data: any, servicio: string, mandarError = true) {
    try {
      const cliente = await this.servicioGen.enviarPeticionCloudRunLogin(data, servicio, 'text');
      const resp: ClsCliente = ClsUtil.parseJSONBig(cliente);

      if (!mandarError || !resp?.errores) {
        return resp;
      }

      const error = ClsUtil.esNulo(resp.errores.error) ? resp.errores.errorDescripcion : resp.errores.error;
      if (ClsUtil.esNulo(error)) {
        return resp;
      }

      const mensaje = error.toLowerCase();
      // Errores que SIEMPRE deben lanzar excepción
      if (mensaje.includes('400 bad request')) {
        throw new Error(error);
      }

      // Errores permitidos (no lanzar)
      const erroresPermitidos = [
        'usuario sin vigencia'
      ];

      const esPermitido = erroresPermitidos.some(e => mensaje.includes(e));

      if (!esPermitido) {
        throw new Error(error);
      }

      return resp;

    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtieneLimitePU(): Promise<ClsRespuestaLimitesPptoPu> {
    let respuesta: ClsRespuestaLimitesPptoPu;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunLogin(ClsUtil.obtenerAccessToken(this.infApp), 'AuthObtieneLimitesPU');
      // modo offline
      if (!respuesta) {
        return null;
      }
      const resp: ClsRespuestaLimitesPptoPu = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.errorDescripcion !== '') {
        throw new Error(resp.Errores.errorDescripcion);
      }
      return resp;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtieneLimitePorUsuario(): Promise<ClsRespuestaLimitesPorUsuario> {
    let respuesta: ClsRespuestaLimitesPorUsuario;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(ClsUtil.obtenerAccessToken(this.infApp), 'ObtieneConsumoXUsuario');
      // modo offline
      if (!respuesta) {
        return null;
      }
      const resp: ClsRespuestaLimitesPorUsuario = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp.Errores.ErrorDescripcion);
      }
      return resp;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerFechaActualizacionConsulta(): Promise<ClsActualizacionConsulta> {
    let respuesta: ClsActualizacionConsulta;
    const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtieneFechaConsulta')
      // modo offline
      if (!respuesta) {
        return null;
      }
      const resp: ClsRespuestaActualizacionConsulta = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp.Errores.ErrorDescripcion);
      }
      return resp.FechaCatalogo;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async previoGenerarEnviarArchivoIntercambio(ppto: ClsCatalogoPresupuestos, desdeRepaldar: boolean, exportarQue: ClsPeticionGenerarArchivoIntercambio): Promise<{
    archivo: ClsRespuestaGenerarArchivoIntercambio,
    siHayDatos: boolean
  }> {
    let archivo: ClsRespuestaGenerarArchivoIntercambio;
    let siHayDatos = false;
    try {
      this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.GEN_RESPALDO');
      // 1) Generar archivo
      archivo = await this.generarArchivoIntercambio(ppto.IdPresupuesto, desdeRepaldar, exportarQue);
      // 2) Validar si trae datos
      siHayDatos = !!(archivo?.NombreArchivo && archivo?.ArchivoIntercambio);
      if (!siHayDatos) {
        return {archivo: null, siHayDatos};
      }
      // 3) Enviar correo
      const email = this.infApp.usuarioLogeado.email;
      this.tipoMsg.actualizarMensaje2(this.getTranslationsSubject('MENSAJES.WAIT.ENVIAR_CORREO').replace('{0}', email));
      await this.enviarCorreoArchivoIntercambio(archivo, ppto);
      return {archivo, siHayDatos};
    } catch (e) {
      if (siHayDatos) {
        ClsUtil.decargarArchivoBase64(archivo.ArchivoIntercambio, archivo.NombreArchivo, EnumMIMETypes.ZIP);
      }
      throw new Error(e.message);
    }
  }

  public async obtenerFechaParaValidar(): Promise<ClsRespuestaFechasConsultas> {
    let respuesta: ClsRespuestaFechasConsultas;
    const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = ClsUtil.bigintX('376257340876711373')
    objPeticion.IdOrganizacion = ClsUtil.bigintX('5145584810992')
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ValidaFechasCatalogoMatrices');
      if (!respuesta) {
        return null;
      }
      const result: ClsRespuestaFechasConsultas = ClsUtil.parseJSONBig(respuesta);
      if (result?.Errores?.ErrorDescripcion !== '') {
        throw new Error(result.Errores.ErrorDescripcion);
      }
      return result;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerCatMatrizStorage(): Promise<ClsRespuestaCatMatrizStorage> {
    let respuesta: ClsRespuestaCatMatrizStorage;
    const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = ClsUtil.bigintX('376257340876711373')
    objPeticion.IdOrganizacion = ClsUtil.bigintX('5145584810992')
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'DescargaCatalogoMatrices');
      if (!respuesta) {
        return null;
      }
      const result: ClsRespuestaCatMatrizStorage = ClsUtil.parseJSONBig(respuesta);
      if (result?.Errores?.ErrorDescripcion !== '') {
        throw new Error(result.Errores.ErrorDescripcion);
      }
      return result;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async buscarAI(
    textoBuscar: string,
    limite: number,
    filterTipo?: BusquedaAITipoFilter,
    filterMatriz?: BusquedaAIMatrizFilter,
    useRerank = false
  ): Promise<ClsVectorSearchRow[]> {
    const resultado = await this.buscarAIConRespuesta(textoBuscar, limite, filterTipo, filterMatriz, useRerank);
    return resultado.data;
  }

  public async buscarAIConRespuesta(
    textoBuscar: string,
    limite: number,
    filterTipo?: BusquedaAITipoFilter,
    filterMatriz?: BusquedaAIMatrizFilter,
    useRerank = false
  ): Promise<ClsBusquedaAIResultado> {
    let respuesta: ClsParametro[];
    const data: ClsVectorSearchRow[] = [];
    const objPeticion: ClsPeticionBusquedaAI = new ClsPeticionBusquedaAI();
    objPeticion.accessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.query = textoBuscar;
    objPeticion.topK = limite;
    objPeticion.useRerank = useRerank;
    objPeticion.filterTipo = filterTipo;
    objPeticion.filterMatriz = filterMatriz;
    try {
      respuesta = await this.servicioGen.enviarPeticionNodeJSAI(objPeticion, 'search');
      if (!respuesta) {
        return new ClsBusquedaAIResultado();
      }
      const result: ClsRespuestaVectorSearchResponse = ClsUtil.parseJSONBig(respuesta);
      if (!result.ok) {
        throw new Error(JSON.parse(result.error).map((err: any) => new ValidationErrorDetail(err)));
      }

      const resp: ClsVectorSearchResult[] = result.results ?? [];
      resp.forEach(item => {
        const registro = new ClsVectorSearchRow();
        const row = item.row ?? {} as any;
        Object.assign(registro, {
          ...row,
          id: row.id ?? row.IdCatalogo ?? '',
          idCatalogo: row.idCatalogo ?? row.IdCatalogo ?? row.id ?? '',
          qualification: item.qualification,
          qualificationNumeric: item.qualificationNumeric,
          codigo: row.codigo ?? row.Codigo ?? '',
          descripcion: row.descripcion ?? row.DescripcionLarga ?? row.descripcionLarga ?? '',
          unidad: row.unidad ?? row.Unidad ?? '',
          tipo: row.tipo ?? row.TipoInsumo ?? '',
          costo: row.costo ?? row.CostoMoneda1 ?? 0,
          fecha: row.fecha ?? row.FechaMoneda1 ?? null,
          score: item.score,
          scoreOriginal: item.scoreOriginal,
          smartScore: item.smartScore,
          smartReason: item.smartReason,
          esMatriz: Boolean(row.esMatriz),
          extra: row
        });
        data.push(registro);
      });

      return {
        data,
        smartHints: result.smartHints ?? [],
        smartMeta: result.smartMeta,
        message: result.message
      };
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async generarArchivoIntercambio(idPresupuesto: bigint, desdeRepaldar: boolean, exportarQue: ClsPeticionGenerarArchivoIntercambio): Promise<ClsRespuestaGenerarArchivoIntercambio> {
    let respuesta: ClsRespuestaGenerarArchivoIntercambio;
    const objPeticion: ClsPeticionGenerarArchivoIntercambio = new ClsPeticionGenerarArchivoIntercambio();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = idPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.ExportarTodo = exportarQue?.ExportarTodo;
    objPeticion.IdPrograma = exportarQue?.IdPrograma;
    objPeticion.ExportInsumos = exportarQue?.ExportInsumos;
    objPeticion.ExportMatrices = exportarQue?.ExportMatrices;
    objPeticion.ExportProgObra = exportarQue?.ExportProgObra;
    objPeticion.ExportLibroFASAR = exportarQue?.ExportLibroFASAR;
    objPeticion.ExportLibroSobrecosto = exportarQue?.ExportLibroSobrecosto;
    objPeticion.ExportLibroIndirectos = exportarQue?.ExportLibroIndirectos;
    objPeticion.ExportarTodasMonedas = exportarQue?.ExportarTodasMonedas;
    objPeticion.ExportMoneda1 = exportarQue?.ExportMoneda1;
    objPeticion.ExportMoneda2 = exportarQue?.ExportMoneda2;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'GeneraArchivoDeIntercambiov2');
      // modo offline
      if (!respuesta) {
        return null;
      }
      const resp = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.ErrorDescripcion !== '') {
        if (resp.Errores.Error === 'DEL01' && desdeRepaldar) {
          throw new Error('MENSAJES.ALERT.NO_HAY_DATOS_RESPALDAR');
        }
        if (resp.Errores.Error !== 'DEL01' && desdeRepaldar) {
          throw new Error(resp.Errores.ErrorDescripcion);
        }
        if (resp.Errores.Error !== 'DEL01' && !desdeRepaldar) {
          throw new Error(resp.Errores.ErrorDescripcion);
        }
      }
      return {ArchivoIntercambio: resp.ArchivoIntercambio, NombreArchivo: resp.NombreArchivo};
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerPlantillaParaCorreo(url: string): Promise<any> {
    try {
      const respuesta = await this.servicioGen.getURLTextAwait(url);
      // modo offline
      if (!respuesta) {
        return null;
      }
      return respuesta;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async enviarPorCorreo(clsECorreo: ClsEnviarCorreo) {
    const servicio = this.infApp.provLogin === ProveedorLogin.Google ? 'AuthEnvioCorreo' : 'AuthEnvioCorreoMicrosoft';
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunLogin(clsECorreo, servicio);
      // modo offline
      if (!respuesta) {
        return;
      }
      const resp = ClsUtil.parseJSONBig(respuesta);
      if (resp?.errores?.errorDescripcion !== '') {
        throw new Error(resp.errores.errorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async depurarPresupuesto(): Promise<number> {
    let respuesta: number;
    const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'DepurarPresupuesto')
      // modo offline
      if (!respuesta) {
        return 0;
      }
      const resp: ClsRespustaDepurarPresupuesto = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp.Errores.ErrorDescripcion);
      }
      return resp.RegistrosBorrados;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async recibirArchivoIntercambio(base64: string, nombre: string) {
    const objPeticion: ClsPeticionRecibirArchivoIntercambio = new ClsPeticionRecibirArchivoIntercambio();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.ArchivoIntercambioB64 = base64;
    objPeticion.NombreArchivo = nombre;
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RecibeArchivoDeIntercambiov2');
      // modo offline
      if (!respuesta) {
        return [];
      }
      const resp: ClsErrores = ClsUtil.parseJSONBig(respuesta);
      if (resp?.ErrorDescripcion !== '') {
        throw new Error(resp.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async unirArchivosIntercambios(lsAIB64: ClsUnirArchivosIntercambios[]): Promise<ClsRespuestaGenerarArchivoIntercambio> {
    let respuesta: ClsRespuestaGenerarArchivoIntercambio;
    const objPeticion: ClsPeticionUnirArchivosIntercambios = new ClsPeticionUnirArchivosIntercambios();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.LsArchivoIntercambioB64 = lsAIB64;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'UnirArchivosIntercambio');
      // modo offline
      if (!respuesta) {
        return null;
      }
      const resp: ClsRespuestaGenerarArchivoIntercambio = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp.Errores.ErrorDescripcion);
      }
      return resp;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  // public async validarObtenerGuardarActualizarParametros(idTipo: bigint, tipoParametro: EnumTipoParametro): Promise<ClsParametro[]> {
  //   let parametrosDefaults: ClsParametro[];
  //   let parametrosPpto: ClsParametro[];
  //   try {
  //     if (tipoParametro === EnumTipoParametro.Presupuesto) {
  //       parametrosDefaults = this.mObjParaPpto.getParametrosDefaults();
  //     }
  //     if (tipoParametro === EnumTipoParametro.Organizacion) {
  //       parametrosDefaults = this.mObjParaOrganizacion.getParametrosDefaults();
  //     }
  //     if (tipoParametro === EnumTipoParametro.Usuario) {
  //       parametrosDefaults = this.mObjParaUser.getParametrosDefaults();
  //     }
  //     parametrosPpto = await this.obtenerParametros(idTipo, tipoParametro);
  //     // validar si estan todos los parametros
  //     if (parametrosPpto.length === parametrosDefaults.length) {
  //       return parametrosPpto;
  //     }
  //     parametrosDefaults.forEach(value => {
  //       const param = parametrosPpto.find(value1 => value1.Parametro === value.Parametro);
  //       if (ClsUtil.esNulo(param)) {
  //         value.Llave = idTipo;
  //         parametrosPpto.push(value);
  //       }
  //     });
  //     parametrosPpto = await this.guardarActualizarParametros(parametrosPpto, tipoParametro);
  //     return parametrosPpto;
  //   } catch (e) {
  //     throw new Error(e.message);
  //   }
  // }

  // public async obtenerParametros(llave: bigint, tipoParametro: EnumTipoParametro): Promise<ClsParametro[]> {
  //   let respuesta: ClsParametro[];
  //   const objPeticion: ClsPeticionObtieneParametros = new ClsPeticionObtieneParametros();
  //   objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
  //   objPeticion.Llave = llave;
  //   objPeticion.TipoParametro = tipoParametro;
  //   respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtieneParametros')
  //     .then(async (resp: any) => {
  //       const result: ClsRespuestaParametros = ClsUtil.parseJSONBig(resp);
  //       try {
  //         if (result.Errores.ErrorDescripcion !== '') {
  //           throw new Error(result.Errores.ErrorDescripcion);
  //         }
  //         return ClsUtil.esNulo(result.Parametro) ? [] : result.Parametro;
  //       } catch (e) {
  //         throw new Error(e.message);
  //       }
  //     });
  //   return respuesta;
  // }

  public async obtenerNParametros(llave: bigint, tipoParametro: EnumTipoParametro, parametros: ClsParametro[]): Promise<ClsParametro[]> {
    let respuesta: ClsParametro[];
    const objPeticion: ClsPeticionObtieneParametros = new ClsPeticionObtieneParametros();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.Parametro = parametros;
    objPeticion.Llave = llave;
    objPeticion.TipoParametro = tipoParametro;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtieneParametrosNuevo');
      // modo offline
      if (!respuesta) {
        return [];
      }
      const result: ClsRespuestaParametros = ClsUtil.parseJSONBig(respuesta);
      if (result?.Errores?.ErrorDescripcion !== '') {
        throw new Error(result.Errores.ErrorDescripcion);
      }
      return result.Parametro ?? [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async registraActualizaNParametros(llave: bigint, tipoParametro: EnumTipoParametro, parametros: ClsParametro[]): Promise<ClsParametro[]> {
    let respuesta: ClsParametro[];
    const objPeticion: ClsPeticionObtieneParametros = new ClsPeticionObtieneParametros();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.Parametro = parametros;
    objPeticion.TipoParametro = tipoParametro;
    objPeticion.Llave = llave;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RegistraActualizaParametrosNuevo');
      // modo offline
      if (!respuesta) {
        return [];
      }
      const result: ClsRespuestaParametros = ClsUtil.parseJSONBig(respuesta);
      if (result?.Errores?.ErrorDescripcion !== '') {
        throw new Error(result.Errores.ErrorDescripcion);
      }
      return result.Parametro ?? [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  // public async guardarActualizarParametros(parametros: ClsParametro[], tipoParametro: EnumTipoParametro): Promise<ClsParametro[]> {
  //   let respuesta: ClsParametro[];
  //   const objPeticion: ClsPeticionGuardarActualizarParametros = new ClsPeticionGuardarActualizarParametros();
  //   objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
  //   objPeticion.Parametro = parametros;
  //   objPeticion.TipoParametro = tipoParametro;
  //   respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RegistraActualizaParametros')
  //     .then(async (resp: any) => {
  //       const result: ClsRespuestaParametros = ClsUtil.parseJSONBig(resp);
  //       try {
  //         if (result.Errores.ErrorDescripcion !== '') {
  //           throw new Error(result.Errores.ErrorDescripcion);
  //         }
  //         return ClsUtil.esNulo(result.Parametro) ? [] : result.Parametro;
  //       } catch (e) {
  //         throw new Error(e.message);
  //       }
  //     });
  //   return respuesta;
  // }

  public async obtenerPlantillaSustituirParametrosHTML(data: ClsCatalogoPresupuestos): Promise<string> {
    let htmlLocal: string;
    const currentLang: string = this.infApp.translate.getCurrentLang()
    try {
      htmlLocal = await this.obtenerPlantillaParaCorreo(`../assets/enviocorreo/${currentLang === 'es' ? 'ES' : 'EN'}/NewPptoRespaldado.html`);
      htmlLocal = htmlLocal.replace('{0}', this.getTranslationsSubject('MENSAJES.GRALS.SUBJECT'));
      htmlLocal = htmlLocal.replace('{1}', `${data.CodigoPresupuesto} ${data.NombrePresupuesto}`);
    } catch (e) {
      throw new Error(e.message);
    }

    return htmlLocal;
  }

  public async obtenerPlantillaSustituirModoPptoHTML(ppto: ClsPresupuestos): Promise<string> {
    let htmlLocal: string;
    const currentLang: string = this.infApp.translate.getCurrentLang()
    const tipoPpto: number = ppto.TipoPresupuesto;
    try {
      htmlLocal = await this.obtenerPlantillaParaCorreo(`../assets/enviocorreo/${currentLang === 'es' ? 'ES' : 'EN'}/NewPptoModoPropioPublico.html`);
      htmlLocal = htmlLocal.replace('{0}', `${this.infApp.usuarioLogeado.name} - ${this.infApp.usuarioLogeado.email}`);
      htmlLocal = htmlLocal.replace('{1}', `${ppto.CodigoPresupuesto} - ${ppto.NombrePresupuesto}`);
      // si es 1, paso de publico a propio y si es 2, paso de propio a publico
      htmlLocal = htmlLocal.replace('{2}', `${tipoPpto === 1 ? this.getTranslationsSubject('MENSAJES.GRALS.PPTOPUBLICO') : this.getTranslationsSubject('MENSAJES.GRALS.PPTOPROPIOS')}`);
      htmlLocal = htmlLocal.replace('{3}', `${tipoPpto === 1 ? this.getTranslationsSubject('MENSAJES.GRALS.PPTOPROPIOS') : this.getTranslationsSubject('MENSAJES.GRALS.PPTOPUBLICO')}`);
    } catch (e) {
      throw new Error(e.message);
    }

    return htmlLocal;
  }

  public crearObjParaEnviarCorreo(de: string, para: string, asunto: string, htmlLocal: string, archivos: ClsArchivoBase64[], conCopiaA: string = ''): ClsEnviarCorreo {
    let clsECorreo: ClsEnviarCorreo;
    const dataEnvioCorreo: ClsDataEnvioCorreo = new ClsDataEnvioCorreo();
    try {
      dataEnvioCorreo.accessToken = ClsUtil.obtenerAccessToken(this.infApp);
      dataEnvioCorreo.from = de;
      dataEnvioCorreo.to = para;
      // se valida que sea distinto el correo para y conCopiaA
      if (conCopiaA.length > 0 && conCopiaA !== para) {
        dataEnvioCorreo.cc = conCopiaA;
      }
      dataEnvioCorreo.subject = asunto;
      dataEnvioCorreo.archivosAdjuntos = archivos;
      clsECorreo = ClsUtil.generarRawToHtml(htmlLocal, dataEnvioCorreo, `${this.getTranslationsNotificaciones()} NEODATA PU NUBE+`, this.infApp.provLogin);
    } catch (e) {
      throw new Error(e.message);
    }

    return clsECorreo;
  }

  public async enviarCorreoArchivoIntercambio(archivoIntercambio: ClsRespuestaGenerarArchivoIntercambio, data: ClsCatalogoPresupuestos) {
    const archivos: ClsArchivoBase64[] = [];
    let htmlLocal: string;
    let clsECorreo: ClsEnviarCorreo;
    let correoCopia: string;
    archivos.push({
      name: `${archivoIntercambio.NombreArchivo}`,
      type: EnumMIMETypes.ZIP,
      base64: archivoIntercambio.ArchivoIntercambio
    });
    try {
      htmlLocal = await this.obtenerPlantillaSustituirParametrosHTML(data);
      // si PresupuestoAgrupador = 3, quiere decir que es compartido y se obtiene el correo creador del ppto, en caso contrario indica que es propio
      // y se manda copia al Admin de la organización
      // en meteodo crearObjParaEnviarCorreo valida que la copia sea diferente al correo que esta logueado
      correoCopia = (data.PresupuestoAgrupador === 3) ? data.EMailUsuarioCreador : this.infApp.usuarioLogeado.emailAdmin;
      clsECorreo = this.crearObjParaEnviarCorreo(this.infApp.usuarioLogeado.email, this.infApp.usuarioLogeado.email, this.getTranslationsSubject('MENSAJES.GRALS.SUBJECT'), htmlLocal, archivos, correoCopia);
      await this.enviarPorCorreo(clsECorreo);
    } catch (e) {
      throw new Error(e.message);
    }

    return clsECorreo;
  }

  public async enviarCorreoModoPresupuesto(ppto: ClsPresupuestos) {
    const archivos: ClsArchivoBase64[] = [];
    let htmlLocal: string;
    let clsECorreo: ClsEnviarCorreo;
    try {
      htmlLocal = await this.obtenerPlantillaSustituirModoPptoHTML(ppto);
      clsECorreo = this.crearObjParaEnviarCorreo(this.infApp.usuarioLogeado.email, ppto.EMailUsuarioCreador, this.getTranslationsSubject('MENSAJES.GRALS.SUBJECT5'), htmlLocal, archivos);
      await this.enviarPorCorreo(clsECorreo);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerListadoPresupuestos(): Promise<ClsCatalogoPresupuestos[]> {
    let dataCatPptoGral: ClsCatalogoPresupuestos[];
    try {
      dataCatPptoGral = await this.mObjCatalogoPptosGrals.obtenerCatalogoPresupuestos();
      dataCatPptoGral.forEach(ppto => {
        ppto.IdPresupuesto = ClsUtil.bigintX(ppto.IdPresupuesto);
        ppto.NivelAccesoS = this.getTranslationsGetTPNA(ClsUtil.nivelAcceso(ppto.NivelAcceso));
        ppto.PresupuestoAgrupadorS = this.getTranslationsGetTPNA(ClsUtil.tipoPresupuesto(ppto.PresupuestoAgrupador));
      });
      // ordenar por PresupuestoAgrupador = 1 = Propios, 2 = publicos, 3 = compartidos, 4 = premium
      // this.dataCatPptoGral = this.dataCatPptoGral.sort((a, b) => a.PresupuestoAgrupador - b.PresupuestoAgrupador);
      return dataCatPptoGral;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async abrirPpto(rowSelected: ClsCatalogoPresupuestos, esMaestro: boolean, guardarUltimo: boolean, cerrarBusqGral = true) {
    let respuesta: ClsRespuestaPresupuestos;
    let paramUltimoPpto: ClsParametro;
    try {
      // actualizar el ppto
      respuesta = await this.mObjCatalogoPptosGrals.obtenerPptoSeleccionado(rowSelected.IdPresupuesto, rowSelected.IdOrganizacion);
      await ClsUtil.descomprimirPptoSeleccionado(respuesta, this.mObjExpInsumos, this.mObjPresupuestoPartida, this.mObjPresupuesto,
        this.mObjCalculo, this.mObjCH, this.mObjMatrices, rowSelected, this.infPpto, esMaestro, guardarUltimo, cerrarBusqGral);
      //  modificar y actualizar ultimo ppto abierto
      if (guardarUltimo) {
        paramUltimoPpto = (esMaestro) ? {
          Parametro: EnumParaUsu.ULTIMOPPTOMAESTROABIERTO,
          Valor: '0'
        } : {Parametro: EnumParaUsu.ULTIMOPPTOABIERTO, Valor: '0'};
        paramUltimoPpto.Valor = ClsUtil.cadenaX(rowSelected.IdPresupuesto);
        await this.registraActualizaNParametros(this.infApp.usuarioLogeado.idUsuario, EnumTipoParametro.Usuario, [paramUltimoPpto]);
      }
      // cambiar exp ins del maestro siempre y cuando tenga uno ppto abierto, en caso de no tener maestro, se asignar
      // la exp ins del ppto
      this.infApp.principal.chkConsultarMaestro = !ClsUtil.esNulo(this.infPpto.pptoSeleccionadoActivo) && !ClsUtil.esNulo(this.infPpto.pptoSeleccionadoMaestro);
      this.infApp.principal.cambiarMaestro();
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async abrirDetallePpto(presupuesto: ClsCatalogoPresupuestos, vtnDetalleDelPpto: DetalleDelPresupuestoComponent): Promise<DetalleDelPresupuestoComponent> {
    try {
      this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.OBTENER_PARAMETROS');
      vtnDetalleDelPpto.paraPpto = await this.obtenerNParametros(presupuesto.IdPresupuesto, EnumTipoParametro.Presupuesto, vtnDetalleDelPpto.mObjParaPpto.getParametrosDetallePpto());
      this.infPpto.setValorRedondeoImporteCantidadExpIns(vtnDetalleDelPpto.paraPpto);
      // 🔥 helper para obtener parámetro rápido
      const getParam = (param: EnumParaPpto): string =>
        vtnDetalleDelPpto.paraPpto.find(p => p.Parametro === param)?.Valor ?? '';

      // 📄 nombres
      const nombreCH = getParam(EnumParaPpto.CHNOMBRELIBROCH);
      const nombreFASAR = getParam(EnumParaPpto.FNOMBRELIBRO);
      const nombreSC = getParam(EnumParaPpto.SOBNOMBRELIBROSC1);
      const nombrePI = getParam(EnumParaPpto.SOBNOMBRELIBROPI1);

      // 🔥 flags
      const nombreFM1Null = ClsUtil.esNulo(nombreFASAR);
      const nombreSCM1Null = ClsUtil.esNulo(nombreSC);
      const nombrePIM1Null = ClsUtil.esNulo(nombrePI);

      this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.DESCARGANDO_DOC');
      const idppto = presupuesto.IdPresupuesto;
      const archivos: ClsArchivosEntrada = {
        CH: nombreCH,
        FASAR: nombreFASAR,
        SC: nombreSC,
        PI: nombrePI
      }
      const mapResp: Map<string, ClsListaArchivos> = await ClsUtil.inicializarListaDeDescargaArchivos(idppto, archivos, this);
      // 🔥 crear mapa por tipo
      // CH
      let ch = mapResp.get(EnumLibros.CH);
      vtnDetalleDelPpto.libroCH = ch;
      vtnDetalleDelPpto.contenidoCH = ch.ContenidoBase64;
      vtnDetalleDelPpto.libroCHAnt = ch.Documento + ch.Extension;
      vtnDetalleDelPpto.busquedaLCH.valorInput = ch.Documento;

      // =======================
      // 🔥 Helper reutilizable
      // =======================
      const setDocumento = (key: string, isNull: boolean, setLibro: (val: any) => void, setBusqueda: (val: string) => void, setContenido: (val: string) => void) => {
        if (isNull) {
          setLibro(undefined);
          setBusqueda('');
          setContenido('');
          return;
        }

        const doc = mapResp.get(key);

        setLibro(doc);
        setBusqueda(doc?.Documento ?? '');
        setContenido(doc?.ContenidoBase64 ?? '');
      };

      // =======================
      // 🚀 FASAR
      // =======================
      setDocumento(EnumLibros.FASAR, nombreFM1Null, v => vtnDetalleDelPpto.libroFM1 = v, v => vtnDetalleDelPpto.busquedaLFASARM1.valorInput = v, v => vtnDetalleDelPpto.contenidoFM1 = v);

      // =======================
      // 🚀 SOBRECOSTO
      // =======================
      setDocumento(EnumLibros.SC, nombreSCM1Null, v => vtnDetalleDelPpto.libroSCM1 = v, v => vtnDetalleDelPpto.busquedaLSCM1.valorInput = v, v => vtnDetalleDelPpto.contenidoSCM1 = v);

      // =======================
      // 🚀 PIE INDIRECTO
      // =======================
      setDocumento(EnumLibros.PI, nombrePIM1Null, v => vtnDetalleDelPpto.libroPIM1 = v, v => vtnDetalleDelPpto.busquedaLPIM1.valorInput = v, v => vtnDetalleDelPpto.contenidoPIM1 = v);

      return vtnDetalleDelPpto;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  /**
   * Este método ayuda a actualizar la data de los grid de los tabs que se encuentran abierto EXP INS, MATRIZ, PPTO COMPLETO, MO, MAT, EQ
   */
  public async actualizarDatosTabsAbiertosPptoActivo() {
    const dmSecunadrio: DmSecundarioComponent = this.infPpto.dmPrincipal.dmSecundarioPptoActivo;
    const expIns: ExplosionDeInsumosComponent = dmSecunadrio.ExpInsumo;
    const matActiva: MatrizActivoComponent = dmSecunadrio.MActivo;
    const pptoCompleto: PptoCompletoComponent = dmSecunadrio.PptoCompleto;
    const catMO: ManoDeObraComponent = dmSecunadrio.MO;
    const catMAT: MaterialesComponent = dmSecunadrio.MAT;
    const catEQ: MaquinariaComponent = dmSecunadrio.EQ;

    // para exp ins aqui no se actuliza la data del grid, ya que el metodo de abrir ppto(this.mObjGenerico.abrirPpto())->
    // await ClsUtil.descomprimirPptoSeleccionado -> dmSecundario.ExpInsumo.dataExpIns = objCatalogo;
    // se encarga de actualizar desde ahi por los acoplados en concepto y matriz
    if (expIns) {
      expIns?.filtrarExpInsumo(expIns.seleccionMostrar);
      expIns?.ExpInsumoAcoplado.onEnterBusExpInsumos(expIns?.ExpInsumoAcoplado.filtroGeneral.input.value)
    }
    // if (matActiva) {
    //   if (matActiva.dataMatricesTemp[matActiva.index].CodigoMatriz === this.updateMatriz.CodigoMatriz) {
    //     const idCatMat: bigint = ClsUtil.esNulo(this.updateMatriz.IdCodigoMatriz) ? ClsUtil.bigintX(this.updateMatriz.IdCodigoMatrizS) : this.updateMatriz.IdCodigoMatriz
    //     const matrizUpdate: ClsMatriz = this.mObjMatrices.buscarMatrizLista(idCatMat);
    //     matActiva.descartarData();
    //     matActiva.gridMatriz.data = this.mObjMatrices.calcularCostosPorcentajes(matrizUpdate.Insumos);
    //     matActiva.dataMatricesTemp[matActiva.index] = matrizUpdate;
    //   }
    // }
    if (pptoCompleto) {
      const tempChkAcumularCodigo: boolean = pptoCompleto?.chkAcumularCodigo.checked;
      pptoCompleto?.inicializarData();
      const valorFiltroTemp = pptoCompleto?.filtroGeneral.input.value;
      pptoCompleto?.clearInputPptoCompleto();
      pptoCompleto?.onEnterBusPptoCompleto(valorFiltroTemp);
      setTimeout(() => {
        pptoCompleto.chkAcumularCodigo.checked = tempChkAcumularCodigo;
        pptoCompleto?.acumularCodigos(tempChkAcumularCodigo);
      }, 100);
    }
    if (catMO) {
      await catMO?.obtenerCatMO();
      const valorFiltroTemp = catMO?.filtroGeneral.input.value;
      catMO?.clearInputBus();
      catMO?.onEnterBus(valorFiltroTemp);
    }
    if (catMAT) {
      catMAT?.obtenerCatMAT();
      const valorFiltroTemp = catMAT?.filtroGeneral.input.value;
      catMAT?.clearInputBus();
      catMAT?.onEnterBus(valorFiltroTemp);
    }
    if (catEQ) {
      catEQ?.obtenerCatEQ();
      const valorFiltroTemp = catEQ?.filtroGeneral.input.value;
      catEQ?.clearInputBus();
      catEQ?.onEnterBus(valorFiltroTemp);
    }
  }

  /**
   * obtener una lista de archivos de algun bucket
   * @param nomBucket
   * @param nomPrefix de la carpeta base, mandar idppto o irorganizacion o idusuario mas el resto de la ruta que necesitas
   * obtener los archivos
   * @param nomArchivo
   * @param formatoMime
   */
  public async obtenerListadoArchivosStorage(nomBucket: string, nomPrefix: string, nomArchivo?: string, formatoMime?: string): Promise<ClsListaArchivos[]> {
    let respuesta: ClsListaArchivos[];
    const objPeticion: ClsPeticionEnListaArchivosStorage = new ClsPeticionEnListaArchivosStorage();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.NombreBucket = nomBucket;
    objPeticion.NombrePrefix = nomPrefix;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'EnlistaArchivosStorage');
      // modo offline
      if (!respuesta) {
        return [];
      }
      const lista: ClsRespuestaEnListaArchivosStorage = ClsUtil.parseJSONBig(respuesta);
      if (lista?.Errores?.ErrorDescripcion !== '') {
        throw new Error(lista.Errores.ErrorDescripcion);
      }
      return lista.ListaArchivos ?? [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async descargarArchivoStorage(nomBucket: string, nomArchivo: string): Promise<ClsRespuestaDescargaArchivosStorage> {
    let respuesta: ClsRespuestaDescargaArchivosStorage;
    const objPeticion: ClsPeticionEliminarObtieneBucketStorage = new ClsPeticionEliminarObtieneBucketStorage();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.NombreBucket = nomBucket;
    objPeticion.NombreArchivo = nomArchivo;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'DescargaArchivosStorage');
      // modo offline
      if (!respuesta) {
        return null;
      }
      const archivo: ClsRespuestaDescargaArchivosStorage = ClsUtil.parseJSONBig(respuesta);
      if (archivo?.Errores?.ErrorDescripcion !== '') {
        throw new Error(archivo.Errores.ErrorDescripcion);
      }
      return archivo;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async descargarListaArchivoStorage(listaArchivos: ClsContenidoBucketStorage[]): Promise<ClsRespuestaDescargaArchivosStorage[]> {
    let respuesta: ClsRespuestaDescargaArchivosStorage2;
    const objPeticion: ClsRespuestaEliminarObtieneBucketStorage = new ClsRespuestaEliminarObtieneBucketStorage();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.LsDatosBucket = listaArchivos;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'DescargaListaArchivosStoragev2');
      // modo offline
      if (!respuesta) {
        return null;
      }
      const archivo: ClsRespuestaDescargaArchivosStorage2 = ClsUtil.parseJSONBig(respuesta);
      if (archivo?.Errores?.ErrorDescripcion !== '') {
        throw new Error(archivo.Errores.ErrorDescripcion);
      }
      return archivo.LsDatosBucket ?? [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async borrarArchivosStorage(nomBucket: string, nomArchivo: string): Promise<void> {
    const objPeticion: ClsPeticionEliminarObtieneBucketStorage = new ClsPeticionEliminarObtieneBucketStorage();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.NombreBucket = nomBucket;
    objPeticion.NombreArchivo = nomArchivo;
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'EliminaArchivosStorage');
      // modo offline
      if (!respuesta) {
        return;
      }
      const error: ClsErrores = ClsUtil.parseJSONBig(respuesta);
      if (error?.ErrorDescripcion !== '') {
        throw new Error(error.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async borrarListaArchivoStorage(listaArchivos: ClsContenidoBucketStorage[]): Promise<ClsContenidoBucketStorage[]> {
    let respuesta: ClsRespuestaDescargaArchivosStorage2;
    const objPeticion: ClsRespuestaEliminarObtieneBucketStorage = new ClsRespuestaEliminarObtieneBucketStorage();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.LsDatosBucket = listaArchivos;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'EliminaListaArchivosStorage');
      // modo offline
      if (!respuesta) {
        return null;
      }
      const error: ClsErrores = ClsUtil.parseJSONBig(respuesta);
      if (error?.ErrorDescripcion !== '') {
        throw new Error(error.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  /**
   * subir cualquier archivo al bucket a nivel ppto, organizacion, usuario
   * @param tipoId EnumTipoParametro si mandas enum ppto, debes mandar el idppto en caso de opcupar otro enum,
   * idppto se manda undefined en caso de ocupar el parametro formatoMime, si no no se manda nada
   * @param nomBucket
   * @param nomArchivo
   * @param contenidoBase64
   * @param idPpto
   * @param formatoMime
   * @param nomPrefix
   */
  public async subirArchivosStorage(tipoId: EnumTipoParametro, nomBucket: string, nomArchivo: string, contenidoBase64: string, idPpto?: bigint, formatoMime?: string, nomPrefix?: string): Promise<string> {
    let respuesta: string;
    const objPeticion: ClsPeticionSubeArchivoStorage = new ClsPeticionSubeArchivoStorage();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    switch (tipoId) {
      case EnumTipoParametro.Presupuesto:
        objPeticion.IdPresupuesto = idPpto;
        break;
      case EnumTipoParametro.Organizacion:
        objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
        break;
      case EnumTipoParametro.Usuario:
        objPeticion.IdUsuario = this.infApp.usuarioLogeado.idUsuario;
        break;
    }
    objPeticion.NombreBucket = nomBucket;
    objPeticion.NombreArchivo = nomArchivo;
    objPeticion.ContenidoArchivo = contenidoBase64;
    if (!ClsUtil.esNulo(formatoMime)) {
      objPeticion.FormatoMIME = formatoMime;
    }
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'SubeArchivosStorage');
      // modo offline
      if (!respuesta) {
        return '';
      }
      const lista: ClsRespuestaSubeArchivoStorage = ClsUtil.parseJSONBig(respuesta);
      if (lista?.Errores?.ErrorDescripcion !== '') {
        throw new Error(lista.Errores.ErrorDescripcion);
      }
      return lista.Resultado ?? '';
    } catch (e) {
      throw new Error(e.message);
    }
  }

  /**
   * Sube varios archivos al bucket en una sola petición (SubeListaDeArchivosStoragev2).
   * Reutiliza una sola conexión a Storage en el servidor.
   */
  public async subirListaArchivosStorageV2(tipoId: EnumTipoParametro, lista: ClsDatosBucketSube[], idPpto?: bigint): Promise<ClsRespuestaSubeListaArchivosStorageV2> {
    if (!lista?.length) {
      const vacio = new ClsErrores();
      vacio.Error = '';
      vacio.ErrorDescripcion = '';
      return {Resultado: 'OK', LsDetalle: [], Errores: vacio};
    }
    const objPeticion = new ClsPeticionSubeListaArchivosStorageV2();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.LsDatosBucket = lista;
    switch (tipoId) {
      case EnumTipoParametro.Presupuesto:
        objPeticion.IdPresupuesto = idPpto;
        break;
      case EnumTipoParametro.Organizacion:
        objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
        break;
      case EnumTipoParametro.Usuario:
        objPeticion.IdUsuario = this.infApp.usuarioLogeado.idUsuario;
        break;
    }
    try {
      const respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'SubeListaDeArchivosStoragev2');
      if (!respuesta) {
        return null;
      }
      const parsed: ClsRespuestaSubeListaArchivosStorageV2 = ClsUtil.parseJSONBig(respuesta);
      if (parsed?.Errores?.ErrorDescripcion) {
        throw new Error(parsed.Errores.ErrorDescripcion);
      }
      const fallas = parsed.LsDetalle?.filter(d => (d?.Errores?.Error ?? '') !== '' || (d?.Errores?.ErrorDescripcion ?? '').trim() !== '');
      if (fallas?.length) {
        throw new Error(
          fallas.map(f => `${f.NombreArchivo ?? f.RutaCompleta ?? '?'}: ${f.Errores?.ErrorDescripcion ?? f.Errores?.Error ?? ''}`).join('; ')
        );
      }
      return parsed;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public disableAllContextMenu(infSis: AppPresupuestosService) {
    let dmSecundario: DmSecundarioComponent;
    let dmSecundarioM: DmSecundarioComponent;
    let dmCatalogosGnral: DmCatalogosGralsComponent;
    dmSecundario = infSis.dmPrincipal.dmSecundarioPptoActivo;
    dmSecundarioM = infSis.dmPrincipal.dmSecundarioPptoMaestro;
    dmCatalogosGnral = infSis.dmPrincipal.dmCatalogosGrals;

    // PPTO
    if (!ClsUtil.esNulo(dmSecundario)) {
      if (!ClsUtil.esNulo(dmSecundario.PptoCompleto)) {
        dmSecundario.PptoCompleto.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmSecundario.Ppto.partidaComponent)) {
        dmSecundario.Ppto.partidaComponent.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmSecundario.Ppto.conceptosComponent)) {
        dmSecundario.Ppto.conceptosComponent.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmSecundario.MActivo)) {
        dmSecundario.MActivo.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmSecundario.ExpInsumo)) {
        if (!ClsUtil.esNulo(dmSecundario.ExpInsumo.ExpInsumoAcoplado)) {
          dmSecundario.ExpInsumo.ExpInsumoAcoplado.disableContextMenu();
        }
      }
      if (!ClsUtil.esNulo(dmSecundario.Ppto.ExpInsumoAcoplado)) {
        dmSecundario.Ppto.ExpInsumoAcoplado.disableContextMenu();
      }
    }
    if (!ClsUtil.esNulo(dmSecundarioM)) {
      if (!ClsUtil.esNulo(dmSecundarioM.PptoCompleto)) {
        dmSecundarioM.PptoCompleto.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmSecundarioM.Ppto.partidaComponent)) {
        dmSecundarioM.Ppto.partidaComponent.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmSecundarioM.Ppto.conceptosComponent)) {
        dmSecundarioM.Ppto.conceptosComponent.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmSecundarioM.MActivo)) {
        dmSecundarioM.MActivo.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmSecundarioM.ExpInsumo)) {
        if (!ClsUtil.esNulo(dmSecundarioM.ExpInsumo.ExpInsumoAcoplado)) {
          dmSecundarioM.ExpInsumo.ExpInsumoAcoplado.disableContextMenu();
        }
      }
    }
    // CATALOGOS
    if (!ClsUtil.esNulo(dmCatalogosGnral)) {
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosCiudad)) {
        dmCatalogosGnral.CatalogosCiudad.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosCli)) {
        dmCatalogosGnral.CatalogosCli.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosEmpresa)) {
        dmCatalogosGnral.CatalogosEmpresa.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosEdo)) {
        dmCatalogosGnral.CatalogosEdo.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosFamilia)) {
        dmCatalogosGnral.CatalogosFamilia.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosProv)) {
        dmCatalogosGnral.CatalogosProv.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosResp)) {
        dmCatalogosGnral.CatalogosResp.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosTipIns)) {
        dmCatalogosGnral.CatalogosTipIns.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosTipLic)) {
        dmCatalogosGnral.CatalogosTipLic.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosUnidad)) {
        dmCatalogosGnral.CatalogosUnidad.disableContextMenu();
      }
      if (!ClsUtil.esNulo(dmCatalogosGnral.CatalogosVendedor)) {
        dmCatalogosGnral.CatalogosVendedor.disableContextMenu();
      }
    }
  }

  /**
   * funcion que valida si tiene cambios pendientes por guardar en los siguientes componentes: Presupuesto, Matriz, Presupuesto completo
   */
  public validarSiHayCambiosPendientesComponentesBatch() {
    try {
      if (this.infPpto.esPptoMaestro || ClsUtil.esNulo(this.infPpto.pptoSeleccionadoActivo)) {
        return;
      }

      const {dmSecundarioPptoActivo} = this.infPpto.dmPrincipal;
      const {dmCatalogosGrals} = this.infPpto.dmPrincipal;

      if (dmSecundarioPptoActivo?.Ppto?.conceptosComponent?.hasTransactions) {
        throw new Error('MENSAJES.ALERT.CAMBIOS_SIN_GUARDAR_CONCEPTOS');
      }
      if (dmSecundarioPptoActivo?.MActivo?.hasTransactions) {
        throw new Error('MENSAJES.ALERT.CAMBIOS_SIN_GUARDAR_MATRIZ');
      }
      if (dmSecundarioPptoActivo?.PptoCompleto?.hasTransactions) {
        throw new Error('MENSAJES.ALERT.CAMBIOS_SIN_GUARDAR_PPTO_COMPLETO');
      }
      if (dmSecundarioPptoActivo?.ProgramaDeObra?.programaPorPorcentajesMontos?.hasTransactions) {
        const cambiosGral = this.getTranslationsSubject('MENSAJES.ALERT.CAMBIOS_SIN_GUARDAR_GRAL');
        const programaObra = this.getTranslationsSubject('MENSAJES.GRALS.PROGRAMA_DE_OBRA');
        throw new Error(cambiosGral.replace('{0}', programaObra));
      }
      if (dmCatalogosGrals?.CatalogosCalendario?.hasTransactions) {
        const cambiosGral = this.getTranslationsSubject('MENSAJES.ALERT.CAMBIOS_SIN_GUARDAR_GRAL');
        const fechasNoLaborables = this.getTranslationsSubject('GRIDS.CALENDARIO_FECHAS.COL_FECHA_NO_LABORABLE');
        throw new Error(cambiosGral.replace('{0}', fechasNoLaborables));
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  /**
   * funcion que valida si tiene cambios pendientes por guardar en los siguientes componentes: Presupuesto, Matriz, Presupuesto completo
   * retorna un arreglo de mensajes para indicar en que componentes tiene cambios por guardar
   */
  public validarSiHayCambiosPendientesComponentesBatchMsg(): string[] {
    const mensajes: string[] = [];

    try {
      if (this.infPpto.esPptoMaestro || ClsUtil.esNulo(this.infPpto.pptoSeleccionadoActivo)) {
        return mensajes; // sin cambios pendientes
      }

      const {dmSecundarioPptoActivo} = this.infPpto.dmPrincipal;

      if (dmSecundarioPptoActivo?.Ppto?.conceptosComponent?.hasTransactions) {
        mensajes.push(this.getTranslationsMensajes('MENSAJES.GRALS.PPTO'));
      }
      if (dmSecundarioPptoActivo?.MActivo?.hasTransactions) {
        mensajes.push(this.getTranslationsMensajes('MENSAJES.GRALS.MATRIZ'));
      }
      if (dmSecundarioPptoActivo?.PptoCompleto?.hasTransactions) {
        mensajes.push(this.getTranslationsMensajes('MENSAJES.GRALS.PPTO_COMPLETO'));
      }

      return mensajes;
    } catch (e: any) {
      throw new Error(e.message);
    }
  }

  public async listadoCorreosPorOrganizacion(validaAdmin: boolean): Promise<ClsLicenciasPU[]> {
    let respuesta: ClsLicenciasPU[];
    const objPeticion: ClsPeticionListaLicenciasVigentes = new ClsPeticionListaLicenciasVigentes();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdEmpresa = this.infApp.usuarioLogeado.idEmpresa;
    objPeticion.ValidaAdmin = validaAdmin;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ListadoCorreosPorOrganizacion');
      // modo offline
      if (!respuesta) {
        return [];
      }
      const resp: ClsRespuestaListaLicenciasVigentes = ClsUtil.parseJSONBig(respuesta);
      if (resp?.errores?.ErrorDescripcion !== '') {
        throw new Error(resp.errores.ErrorDescripcion);
      }
      return resp.licenciasPU ?? [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerUltimoModifico(opcion: number, idBusqueda: bigint): Promise<ClsRespuestaUltimoModifico> {
    let respuesta: any;
    const objPeticion: ClsPeticionObtieneUltimoModifico = new ClsPeticionObtieneUltimoModifico();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.Opcion = opcion;
    objPeticion.IdBusqueda = idBusqueda;
    objPeticion.IdPresupuesto = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtieneUsuarioUltimaModificacion');
      // modo offline
      if (!respuesta) {
        return null;
      }
      const result: ClsRespuestaUltimoModifico = ClsUtil.parseJSONBig(respuesta);
      if (result?.Errores?.ErrorDescripcion !== '') {
        throw new Error(result.Errores.ErrorDescripcion);
      }
      return {Usuario: result.Usuario, FechaEdicion: result.FechaEdicion};
    } catch (e) {
      throw new Error(e.message);
    }
  }

  // public async validarSiPerteneceAOtraOrganizacion(): Promise<ClsRespuesaOtraOrganizacion> {
  //   let respuesta: any;
  //   const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
  //   objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
  //   respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtieneUsuarioUltimaModificacion')
  //     .then(async (resp: any) => {
  //       const result: ClsRespuesaOtraOrganizacion = ClsUtil.parseJSONBig(resp);
  //       try {
  //         if (result.Errores.ErrorDescripcion !== '') {
  //           throw new Error(result.Errores.ErrorDescripcion);
  //         }
  //         return result;
  //       } catch (e) {
  //         throw new Error(e.message);
  //       }
  //     });
  //   return respuesta;
  // }

  public inicializarVtnDocumentos(listaArchivos: ClsListaArchivos[]): ListaDocumentosComponent {
    try {
      const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
      vtnGenerico.queVtnEstaAbierta = 'DetalleRegistro';
      const vtnListadoDoc: ListaDocumentosComponent = vtnGenerico.crearComponente(ListaDocumentosComponent);
      vtnListadoDoc.listaArchivos = listaArchivos;
      vtnListadoDoc.open();
      return vtnListadoDoc;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public inicializarVtnVistaPreviaExcel(titulo: string, tituloExportar: string, keyVentanaPreviewExcel = KeyVentanaPreviewExcel.DEFAULT, pantallaCompleta = false, altoVtn = 600, anchoVtn = 1000): VistaPreviaExcelComponent {
    try {
      const vtnGenerico: VtnGenericaComponent = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
      vtnGenerico.queVtnEstaAbierta = 'DetalleRegistro';
      vtnGenerico.verIconoMaxMin = true;
      vtnGenerico.verExportar = true;
      vtnGenerico.pantallaCompleta = pantallaCompleta;
      const vtnVistaPreviaExcel: VistaPreviaExcelComponent = vtnGenerico.crearComponente(VistaPreviaExcelComponent);
      vtnVistaPreviaExcel.verBotones = true;
      vtnVistaPreviaExcel.altoVtn = altoVtn;
      vtnVistaPreviaExcel.anchoVtn = anchoVtn;
      vtnVistaPreviaExcel.verCargarArchivo = true;
      vtnVistaPreviaExcel.titulo = titulo;
      vtnVistaPreviaExcel.tituloExportar = tituloExportar;
      vtnVistaPreviaExcel.nombreDocumento = tituloExportar;
      vtnVistaPreviaExcel.VENTANAPREVIEW = keyVentanaPreviewExcel;
      vtnVistaPreviaExcel.titulo += `: ${vtnVistaPreviaExcel.tituloExportar}`;
      vtnVistaPreviaExcel.icono = 'description';
      vtnVistaPreviaExcel.open();
      return vtnVistaPreviaExcel;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtnerCatalogoMonedas(idPresupuesto: bigint): Promise<string[]> {
    const parametros: ClsParametro[] = [{Parametro: EnumParaPpto.DESCRIPCIONMONEDA1}, {Parametro: EnumParaPpto.DESCRIPCIONMONEDA2}];
    const params: ClsParametro[] = await this.obtenerNParametros(idPresupuesto, EnumTipoParametro.Presupuesto, parametros);
    // Crea un mapa para una búsqueda más eficiente
    const paramMap = new Map(params.map(param => [param.Parametro, param.Valor]));

    // Obtén los valores correspondientes a los parámetros deseados
    return [
      paramMap.get(EnumParaPpto.DESCRIPCIONMONEDA1) ?? '',
      paramMap.get(EnumParaPpto.DESCRIPCIONMONEDA2) ?? ''
    ];
  }

  public async generaObjPrevioEnviarArchivoIntercambio(idPresupuesto: bigint, idPrograma?: bigint): Promise<ClsPeticionGenerarArchivoIntercambio> {
    let exportarQue = new ClsPeticionGenerarArchivoIntercambio();
    if (ClsUtil.esNulo(idPrograma)) {
      const parametros: ClsParametro[] = await this.obtenerNParametros(idPresupuesto, EnumTipoParametro.Presupuesto, this.mObjProgramacionObra.getParametrosPrograma());
      idPrograma = ClsUtil.bigintX(parametros.find(para => para.Parametro === EnumParaPpto.IDPROGRAMA)?.Valor ?? '0');
    }
    exportarQue.ExportarTodo = true;
    exportarQue.IdPrograma = idPrograma;

    return exportarQue;
  }

  //#region Traduccion
  public getTranslationsTitulosCatalogos(catalogo: string): string {
    let titulo: string;
    const translations: any = ClsUtil.getTranslations(['MENSAJES.GRALS.CATALOGO', catalogo], this.infApp);
    titulo = `${translations['MENSAJES.GRALS.CATALOGO'].toString()} ${translations[catalogo].toString()}`;
    return titulo;
  }

  public getTranslationsGetTPNA(tipoonivel: string): string {
    return ClsUtil.getTranslations([tipoonivel], this.infApp)[tipoonivel].toString();
  }

  public getTranslationsGetCatalogos(catalogo: string): string {
    return ClsUtil.getTranslations([catalogo], this.infApp)[catalogo].toString();
  }

  public getTranslationsSmsExportar(sms: string, numRegistro: number): string {
    return ClsUtil.getTranslations([sms], this.infApp)[sms].toString().replace('{0}', numRegistro);
  }

  public getTranslationsNotificaciones(): string {
    return ClsUtil.getTranslations(['MENSAJES.GRALS.NOTIFICACION'], this.infApp)['MENSAJES.GRALS.NOTIFICACION'].toString();
  }

  public getTranslationsSubject(subject): string {
    return ClsUtil.getTranslations([subject], this.infApp)[subject].toString();
  }

  public getTranslationValidarColuma(columna: string): string {
    return ClsUtil.getTranslations([columna], this.infApp)[columna].toString();
  }

  public getTranslationsMensajes(etiqueta): string {
    return ClsUtil.getTranslations([etiqueta], this.infApp)[etiqueta].toString();
  }

  public getTranslationsQuestionBorrar(registro: string): string {
    return ClsUtil.getTranslations(['MENSAJES.QUESTION.ELIMINAR_REGISTRO'], this.infApp)['MENSAJES.QUESTION.ELIMINAR_REGISTRO'].toString().replace('{0}', registro);
  }

  public getTranslationsQuestionBorrarIntercambio(ppto: string): string {
    return ClsUtil.getTranslations(['MENSAJES.QUESTION.REEMPLAZAR_DATOS_INTERCAMBIO'], this.infApp)['MENSAJES.QUESTION.REEMPLAZAR_DATOS_INTERCAMBIO'].toString().replace('{0}', ppto);
  }

  public getTranslationsQuestionBorrarPpto(ppto: string): string {
    return ClsUtil.getTranslations(['MENSAJES.QUESTION.REEMPLAZAR_DATOS_PEGADO_ESPECIAL'], this.infApp)['MENSAJES.QUESTION.REEMPLAZAR_DATOS_PEGADO_ESPECIAL'].toString().replace('{0}', ppto);
  }

  public getTranslationsQuestionRespaldoMailDepurar(ppto: string, correo: string): string {
    return ClsUtil.getTranslations(['MENSAJES.QUESTION.RESPALDO_ENVIAR_DEPURAR_PPTO'], this.infApp)['MENSAJES.QUESTION.RESPALDO_ENVIAR_DEPURAR_PPTO'].toString().replace('{0}', ppto).replace('{1}', correo);
  }

  public getTranslationsQuestionRespaldoMailDepurar2(correo: string, codigoPpto: string): string {
    return ClsUtil.getTranslations(['MENSAJES.QUESTION.RESPALDO_ENVIAR_DEPURAR_PPTO_2'], this.infApp)['MENSAJES.QUESTION.RESPALDO_ENVIAR_DEPURAR_PPTO_2'].toString().replace('{0}', correo).replace('{1}', codigoPpto);
  }

  public getTranslationsAlertValidarCampos(campo: string): string {
    return ClsUtil.getTranslations(['MENSAJES.ALERT.VALIDAR_CAMPO'], this.infApp)['MENSAJES.ALERT.VALIDAR_CAMPO'].toString().replace('{0}', campo);
  }

  public getTranslationsAlertRegistroExistente(usuario: string): string {
    return ClsUtil.getTranslations(['MENSAJES.ALERT.REGISTRO_EXISTENTE'], this.infApp)['MENSAJES.ALERT.REGISTRO_EXISTENTE'].toString().replace('{0}', usuario);
  }

  public getTranslationsAlertReinicar(error: string): string {
    return ClsUtil.getTranslations(['MENSAJES.ALERT.REINICIAR_SISTEMA'], this.infApp)['MENSAJES.ALERT.REINICIAR_SISTEMA'].toString().replace('{0}', error);
  }

  public getTranslationsAlertPptoDepurado(numRegistro: number): string {
    return ClsUtil.getTranslations(['MENSAJES.ALERT.NUM_REGISTROS_DEPURADOS'], this.infApp)['MENSAJES.ALERT.NUM_REGISTROS_DEPURADOS'].toString().replace('{0}', numRegistro);
  }

  public getTranslationsWaitEliminarPpto(codigoPpto: string): string {
    return ClsUtil.getTranslations(['MENSAJES.WAIT.BORRAR_PPTO'], this.infApp)['MENSAJES.WAIT.BORRAR_PPTO'].toString().replace('{0}', codigoPpto);
  }

  public getTranslationsToasPptoEliminado(codigoPpto: string): string {
    return ClsUtil.getTranslations(['MENSAJES.TOAS.BORRAR_PPTO'], this.infApp)['MENSAJES.TOAS.BORRAR_PPTO'].toString().replace('{0}', codigoPpto);
  }

  //#endregion
}
